<template>
    <div>
        <modal-layer
            v-for="(panel, key) in panels"
            :key="`panel-${key}`"
            :class="sidePanelModalLayerClass(panel)"
            :handle-focus="panel.focus"
            :react-to-events="shouldPanelReactToEvents(key)"
            :skip-trapping-focus-when-this-element-gets-focus="
                panel.skipTrappingFocusWhenThisElementGetsFocus
            "
            :style="panelStackStyle(panel)"
            :transition="sidePanelModalLayerTransition(panel)"
            class="d-flex"
            @escape="panel.onEscape"
            @click-outside="panel.onClickOutside"
        >
            <component
                :is="panel.component"
                v-bind="panel.props"
                v-on="panel.on"
            />
        </modal-layer>
    </div>
</template>

<script>
import ModalLayer from "~/components/ModalLayer"
import { HEADER_HEIGHT } from "~/lib/constants"

export default {
    props: {
        panels: {
            type: Object,
            default: () => {},
        },

        reactToEvents: Boolean,
    },

    methods: {
        panelStackStyle(panel) {
            const isFullScreen = panel?.fullScreen
                ? panel.fullScreen(this)
                : false
            if (isFullScreen) {
                return {
                    zIndex: 201,
                }
            } else {
                return {
                    zIndex: 100,
                    marginTop: `${HEADER_HEIGHT}px`,
                }
            }
        },

        sidePanelModalLayerClass({ overlayClass, enterFrom }) {
            return {
                [overlayClass]: true,
                "justify-content-start": enterFrom === "left",
                "justify-content-end": enterFrom === "right",
                "flex-column justify-content-start": enterFrom === "top",
                "flex-column justify-content-end": enterFrom === "bottom",
            }
        },

        sidePanelModalLayerTransition({ enterFrom }) {
            switch (enterFrom) {
                case "right":
                    return "side-panel-right"
                case "left":
                    return "side-panel-left"
                case "top":
                    return "side-panel-top"
                case "bottom":
                    return "side-panel-bottom"
                default:
                    throw new Error(
                        `Unexpected value for enterFrom: ${enterFrom}`
                    )
            }
        },

        shouldPanelReactToEvents(key) {
            if (!this.reactToEvents) return false

            const keys = Object.keys(this.panels)
            const topPanelKey = keys[keys.length - 1]
            return key === topPanelKey
        },
    },

    components: {
        ModalLayer,
    },
}
</script>
